import { shallowRef } from 'vue'
import yText from './yText.vue'
import yTitle from './yTitle.vue'
import yPicture from './yPicture.vue'
import yDivider from './yDivider.vue'
import yButton from './yButton.vue'
import yFoldSelect from './yFoldSelect.vue'
import yFoldButton from './yFoldButton.vue'
import yTimeSelect from './yTimeSelect.vue'
import yTextButton from './yTextButton.vue'
import yTextPicture from './yTextPicture.vue'
import yTextFoldSelect from './yTextFoldSelect.vue'
import yTextFoldButton from './yTextFoldButton.vue'
import yTextTimeSelect from './yTextTimeSelect.vue'
import yTitleText from './yTitleText.vue'
import yCoupons from './yCoupons.vue'
import yRedPacket from './yRedPacket.vue'


const previewModule = {
  YText: shallowRef(yText), //文本
  YTitle: shallowRef(yTitle), //标题
  YPicture: shallowRef(yPicture), //图片组
  YDivider: shallowRef(yDivider), //分割线
  YButton: shallowRef(yButton), //按钮
  YFoldSelect: shallowRef(yFoldSelect), //列表选择器
  YFoldButton: shallowRef(yFoldButton), //折叠按钮
  YTimeSelect: shallowRef(yTimeSelect), //日期选择器
  YTextButton: shallowRef(yTextButton), //文本加按钮
  YTextPicture: shallowRef(yTextPicture), //文本加图片
  YTextFoldSelect: shallowRef(yTextFoldSelect), //文本加列表选择器
  YTextFoldButton: shallowRef(yTextFoldButton), //文本加折叠按钮
  YTextTimeSelect: shallowRef(yTextTimeSelect), //文本加日期选择器
  YTitleText: shallowRef(yTitleText), //标题加文本
  YCoupons: shallowRef(yCoupons), //卡劵
  YRedPacket: shallowRef(yRedPacket) //红包
}

export default previewModule
